<router-outlet></router-outlet>
<div class="loading-overlay" *ngIf="loading$ | async">
  <div class="spinner-container">
    <mat-spinner [diameter]="50" color="primary"></mat-spinner>
  </div>
</div>
